document.addEventListener("turbo:load", function() {
  const Container = $("#js-qualified-profile-overlay");
  const Button = $("#js-qualified-profile-overlay-toggle");

  Button.click(function () {
    console.log("");
    Container.toggle();

    const ButtonText = $('#js-button-text');

    if (ButtonText.text() === "Hinweis Verbergen") {
      ButtonText.text('Hinweis Einblenden')
    } else {
      ButtonText.text('Hinweis Verbergen')
    };

  });

})
